import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import frLocale from 'date-fns/locale/fr';
import React from 'react';
import TextField from '@mui/material/TextField';
import {
    DATETIME_FORMAT, DATE_FORMAT, formatDate, isValidDate, parseDate, translate
} from 'utils/helpers';

export const Datepicker = ({
                               dataCy = '',
                               disableFuture = false,
                               disablePast = false,
                               disabled = false,
                               error = false,
                               format = DATE_FORMAT,
                               label = 'common.date',
                               maxDate,
                               minDate,
                               name = '',
                               onChange,
                               onError = () => { },
                               required = false,
                               style,
                               value
                           }: {
    dataCy?: string,
    disableFuture?: boolean,
    disablePast?: boolean,
    disabled?: boolean,
    error?: boolean,
    format?: string,
    label?: string,
    maxDate?: string,
    maxDateMessage?: string,
    minDate?: string,
    minDateMessage?: string,
    name?: string,
    onChange: (date: string) => void,
    onError?: (e: any) => void,
    required?: boolean,
    style?: any,
    value: string
}) => (
  <LocalizationProvider dateAdapter={AdapterDateFns} locale={frLocale}>
    <DatePicker
            disabled={disabled}
            disableFuture={disableFuture}
            disablePast={disablePast}
            inputFormat={DATE_FORMAT}
            label={translate(label)}
            maxDate={maxDate ? parseDate(maxDate, format) : undefined}
            minDate={minDate ? parseDate(minDate, format) : undefined}
            renderInput={(params) => (
              <TextField
                    {...params}
                    error={error}
                    helperText={error ? translate('errors.invalidDate') : params.helperText}
                    inputProps={{
                        ...params.inputProps,
                        'data-cy': dataCy
                    }}
                    name={name}
                    required={required}
                    style={style}
                />
            )}
            value={value ? parseDate(value, format) : null}
            onChange={(date: Date | null) => (date && isValidDate(date) ? onChange(formatDate(date, format)) : onChange(''))}
            onError={onError}
        />
  </LocalizationProvider>
);

export const DateTimepicker = ({
                                   ampm = false,
                                   dataCy = '',
                                   disableFuture = false,
                                   disablePast = false,
                                   disabled = false,
                                   error = false,
                                   format = DATETIME_FORMAT,
                                   label = 'common.date',
                                   maxDate,
                                   maxDateMessage = 'warnings.date.minDate',
                                   minDate,
                                   minDateMessage = 'warnings.date.maxDate',
                                   name = '',
                                   onChange,
                                   required = false,
                                   style,
                                   value
                               }: {
    ampm?: boolean,
    dataCy?: string,
    disableFuture?: boolean,
    disablePast?: boolean,
    disabled?: boolean,
    error?: boolean,
    format?: string,
    label?: string,
    maxDate?: string,
    maxDateMessage?: string,
    minDate?: string,
    minDateMessage?: string,
    name?: string,
    onChange: (date: string) => void,
    required?: boolean,
    style?: any,
    value: string
}) => (
  <LocalizationProvider dateAdapter={AdapterDateFns} locale={frLocale}>
    <DateTimePicker
            ampm={ampm}
            disabled={disabled}
            disableFuture={disableFuture}
            disablePast={disablePast}
            inputFormat={DATETIME_FORMAT}
            label={translate(label)}
            maxDate={maxDate ? parseDate(maxDate, format) : undefined}
            minDate={minDate ? parseDate(minDate, format) : undefined}
            renderInput={(params) => (
              <TextField
                    {...params}
                    error={error}
                    helperText={error ? translate('errors.invalidDate') : params.helperText}
                    inputProps={{
                        ...params.inputProps,
                        'data-cy': dataCy
                    }}
                    name={name}
                    required={required}
                    style={style}
                />
            )}
            value={value ? parseDate(value, format) : null}
            onChange={(date: Date | null) => (date && isValidDate(date) ? onChange(formatDate(date, format)) : onChange(''))}
        />
  </LocalizationProvider>
);
